/* eslint-disable no-use-before-define */
import styled from 'styled-components'
import { BlogThreshold as Threshold } from '../../../constants/theme'
import Colors from '../../../constants/colors'
import PropTypes from 'prop-types'

export const MembersLink = styled.div`
  position: absolute;
  top: 22px;
  right: 50px;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-family: StolzlMedium, sans-serif;
  font-size: 14px;
  line-height: 20px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: ${Colors.primary};

  svg {
    margin-left: 18px;
  }
  
  @media (max-width: ${Threshold.phone}) {
    position: relative;
    top: 0;
    left: 0;
    margin-top: 20px;

    &::after {
      content: '';
      width: 8px;
      height: 6px;
      margin-left: auto;
      background-repeat: no-repeat;
      background-image: url("data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.23178 5.07814C3.63157 5.55789 4.36843 5.55789 4.76822 5.07813L7.63318 1.64018C8.17595 0.988856 7.7128 0 6.86496 0H1.13504C0.287204 0 -0.175952 0.988857 0.36682 1.64018L3.23178 5.07814Z' fill='%23934CBC'/%3E%3C/svg%3E");
      transform: ${_ => _.isOpen? 'rotate(180deg)' : 'none'};
      transition: 0.2s;
    }

    svg {
      order: -1;
      margin-left: 0;
      margin-right: 18px;
    }
  }
`
MembersLink.propTypes = {
  isOpen: PropTypes.bool
}

export const MembersPopover = styled.div`
  position: absolute;
  z-index: 10;
  left: -15px;
  top: 50px;
  display: ${_ => _.isShown ? 'flex' : 'none'};
  max-width: 820px;
  width: 100%;
  padding: 25px 36px 25px 39px;
  box-shadow: 0px 0px 28px rgba(107, 18, 159, 0.13);
  border-radius: 20px;
  background-color: white;
  font-family: StolzlMedium, sans-serif;
  letter-spacing: 1px;
  font-size: 14px;
  line-height: 30px;
  color: black;
  text-transform: none;

  .col {
    flex-basis: 50%;
  }

  .title {
    color: ${Colors.primary};
    margin-bottom: 25px;
  }

  .text {
    font-family: StolzlLight, sans-serif;
  }

  @media (max-width: ${Threshold.phone}) {
    position: static;
    flex-direction: column;
    box-shadow: none;
    border-radius: 0;
    padding: 0;
    margin-top: 25px;

    .col {
      flex-basis: 100%;
    }
    
    .col+.col {
      margin-top: 20px;
    }
  }
`
MembersPopover.propTypes = {
  isShown: PropTypes.bool
}

export const PopoverCloseBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 25px;
  right: 30px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #CD5555;
  cursor: pointer;

  &:before {
    content: '';
    position: absolute;
    width: 10px;
    height: 2px;
    border-radius: 2px;
    background-color: white;
    transform: rotate(-45deg);
    transform-origin: center;
  }

  &:after {
    content: '';
    position: absolute;
    width: 10px;
    height: 2px;
    border-radius: 2px;
    background-color: white;
    transform: rotate(45deg);
    transform-origin: center;
  }

  @media (max-width: ${Threshold.phone}) {
    display: none;
  }
`
